import { gql } from 'graphql-request';

export const REVOKE_SHIPMENT_TASKS = gql`
  mutation App5182dd71_Document($documentIds: [String!]!) {
    app5182dd71_ShipmentTask {
      terminate(documentIds: $documentIds) {
        status
        message {
          ru
          en
        }
      }
    }
  }
`;
